import { Link } from "react-router-dom"
import "./customButton.css"

export function CustomButton({ path, text, color, btnLink, btnFunction }) {
    return (
        <>
            {
                btnLink ?
                    <Link
                        to={path}
                        className={`custom-btn button-link rounded-1 ${color}`}>
                            {text}
                    </Link>
                    :
                    <button onClick={btnFunction} className={`custom-btn rounded-1 ${color}`}>
                        {text}
                    </button>
            }
        </>
    )
}